var exports = {
  "kL": "TextToSpeech.module__container___ODBiWD",
  "$J": "TextToSpeech.module__linkButton___ODBiWD",
  "h3": "TextToSpeech.module__helperCallout___ODBiWD",
  "E$": "TextToSpeech.module__helperIcon___ODBiWD",
  "cy": "TextToSpeech.module__helperText___ODBiWD",
  "Cc": "TextToSpeech.module__narrationSection___ODBiWD",
  "qE": "TextToSpeech.module__narrationHeader___ODBiWD",
  "hC": "TextToSpeech.module__narrationTitle___ODBiWD",
  "Hb": "TextToSpeech.module__narrationDescription___ODBiWD",
};

module.exports = exports;
